module.exports = __webpack_public_path__ + "static/18-537ae3b42d7ce3430c4295da5192dd52.jpg";